import React, { Component } from 'react';

import styled from 'styled-components';


const StyledDiv = styled.div`
    background: rgb(15, 15, 15, 100%);
    display: flex;
   
    justify-content: center;
    flex-direction: column;
    color: white;
    height: 100vh;
    padding-left: 130px;
    padding-right: 309px;
    max-width: 1065px;

    // @media screen and (max-width: 1068px) {
    //     // padding-top: 80px;
    //     max-width: unset;
    //     // min-width: 100%;
    //     width: 60vw;
    // }

    @media screen and (max-width: 1068px) {
        padding-top: 80px;
        max-width: 100vw;
        // min-width: 100vw;
        width: auto;
        max-height: 75vh;
        min-height: 75vh;
    }

    @media screen and (max-width: 654px) {
        padding-left: 0;
        padding-right: 0;
    }

    @media screen and (max-width: 425px) {
        display: none;
    }
    
`;

const StyledText = styled.text`
    color: #E2E2E2;
    font-family: Poppins;
    font-size: 64px;
    font-style: normal;
    font-weight: normal;
    line-height: 96px;

    @media screen and (max-width: 1244px) {
        font-size: 48px;
        line-height: 68px;
    }

    @media screen and (max-width: 1209px) {
        width: 150%;
    }

    @media screen and (max-width: 654px) {
        width: 100vw;
        padding-left: 15vw;
    }
`;

const LogoText = styled.text`
    font-size: 36px;
    font-weight: 600;
    line-height: 54px;
`;

const LogoImage = styled.img`
    transform: translateY(16px);
`;

const LogoDiv = styled.div`
    color: #fff;
    position: absolute;
    padding-top: 73px;
    padding-left: 130px;
    // padding-bottom: 178px;

    @media screen and (max-width: 654px) {
        width: 100vw;
        padding-left: 15vw;
    }

    @media screen and (max-width: 425px) {
        display: none;
    }
`;

const Logo = (props) => {
    return (
        <LogoDiv>
            <LogoImage alt="Shift Planner Logo" src="ant-design_schedule-outlined.svg" /><LogoText>Shift Planner</LogoText>
        </LogoDiv>
    );
}

class HeroDiv extends Component {
    render() {
        return (
            <React.Fragment>
                <Logo />
                <StyledDiv>
                    <StyledText>Spend less time creating schedules. Automate it.</StyledText>
                </StyledDiv>
            </React.Fragment>
        );
    }
}

export default HeroDiv;